// Options shown in the tailor modal. `id` matches the `interests` on each item in data/work.js.
const interests = [
  {
    id: "game",
    title: "🎮 Game Development",
    label: "Game Development",
    description: "Unreal Engine, C++, Unity, multiplayer, gameplay systems",
  },
  {
    id: "web",
    title: "🌐 Web / Software",
    label: "Web / Software",
    description: "React, TypeScript, Node, full-stack engineering",
  },
  {
    id: "mobile",
    title: "📱 Mobile Development",
    label: "Mobile Development",
    description: "React Native, mobile architecture, product development",
  },
  {
    id: "all",
    title: "👋 Just Browsing",
    label: "Everything",
    description: "Show me everything",
  },
];

export default interests;
